export interface PhoenixIconProps {
  icon: string;
  className?: string;
  onClick?: () => void;
  dataTestId?: string;
}

export const PhoenixIcon = ({ className = 'h-4 w-4', icon, onClick, dataTestId }: PhoenixIconProps) => {
  return (
    <svg className={className} onClick={onClick} data-testid={dataTestId}>
      <use xlinkHref={`${icon}#img`} />
    </svg>
  );
};
